import {
    Box,
    Typography
} from "@mui/material";

import { BatchLinkRegistryForm } from "../../components/linkRegistry/BatchLinkRegistryForm";
import { RoundedCard } from "../../componentsV2/misc/RoundedCard";
import globalStyle from "../../assets/style/globalStyle";
import { usePageDefaultStyle } from "../../assets/style/usePageDefaultStyle";

export const CustomerLinkBatchSetUpPage = () => {

    const globalClasses = globalStyle();
    const { pageDefaultStyle } = usePageDefaultStyle();

    return (
        <Box sx={pageDefaultStyle}>
            <Box className={globalClasses.managerLayout}>
                <Typography variant="h4">
                    Bulk Customer Link Set Up
                </Typography>
                <RoundedCard>
                    <BatchLinkRegistryForm/>
                </RoundedCard>
            </Box>
        </Box>
    );
};